import React from "react";
import ProcurementDashboard from "../pages/Dashboard/ProcurementDashboard";
import WarehouseDashboard from "../pages/Dashboard/WarehouseDashboard";
import SalesDashborad from "../pages/Dashboard/SalesDashboard";
import AgriPromoterDashborad from "../pages/Dashboard/AgriPromoterDashborad";

const Home = () => {
  const useCase = localStorage.getItem("useCase");
  return (
    <>
      {useCase === "Procurement" && <ProcurementDashboard />}
      {useCase === "Seed Production" && <ProcurementDashboard />}
      {useCase === "AdminPanel" && <ProcurementDashboard />}
      {useCase === "Warehouse" && <WarehouseDashboard />}
      {useCase === "Sales" && <SalesDashborad />}
      {useCase === "Agri Promoter" && <AgriPromoterDashborad />}
    </>
  );
};

export default Home;
